import React from 'react';
import { Link } from 'react-router-dom';
import './WhoWeAreSection.css';

const WhoWeAreSection = () => {
  return (
    <section className="who-we-are-section">
      <div className="who-we-are-container">
        <div className="who-we-are-text">
          <h2 className="who-we-are-heading">Who We Are</h2>
          <p className="who-we-are-description">
            Martin Advertising is a full-service agency dedicated to driving local dealership success.
            As part of one of the nation's largest automotive retail marketing networks, we specialize
            in delivering iMR-compliant, high-impact creative and media solutions that help Buick, GMC,
            and Cadillac dealers win in their markets.
          </p>
          <Link to="/contact" className="talk-to-us-btn">
            TALK TO US
          </Link>
        </div>
        <div className="who-we-are-image">
          <img
            src="/images/creativeSample.jpg"
            alt="Cadillac Advertisement Sample"
          />
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;
